import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'
import {BadgeSize, BadgeType, BadgeVariant} from './types'
import {getBackgroundColor, getBorderRadius, getColor, getSize} from './utils'

export const TwBadge = tw.div<{
  $type: BadgeType
  $variant: BadgeVariant
  $size: BadgeSize
  $unread: boolean
}>`
  select-none
  flex
  flex-row
  items-center
  justify-center
  px-4
  font-semibold
  text-11
  leading-3
  ${p =>
    cn(
      getSize(p.$size),
      getBorderRadius(p.$type, p.$size),
      getColor(p.$type, p.$variant, p.$unread),
      getBackgroundColor(p.$type, p.$variant, p.$unread)
    )}
`
